import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Button, Col, Container, Row, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import ChemEdit from '../ChemEdit';
import { withRouter } from '../withRouter';
import QueryTable from '../QueryTable';
import HashLink from '../HashLink';
import { PencilSquare, PlusSquare } from 'react-bootstrap-icons';

class Projects extends ChemComponent {
	constructor(props) {
		super(props);

		// start with from date of 90 days ago
		var from90Days = new Date();
		from90Days.setDate(from90Days.getDate() - 90);
		
		var search = {
			PROJECT_ID: null,
			PROJECT_NAME: '',
			PROJECT_DESC: '',
			START_FROM: null,
			START_TO: null,
			CONTACT_ID: null,
			PI_ID: null,
			SPEEDTYPE: '',
			STATUS_ID: null,
			MODIF_FROM: null,
			MODIF_TO: null,
			PAGE_SEARCH: '',
			ORDER_BY: ['PROJECT_ID desc']
		};
		
		var projectListInit = this.copyTable(projectList);
		projectListInit.ajax.data = {
			search: search
		};

		this.state = {
			search: search,
			projectSearch: this.copyProjectSearch(),
			projectList: projectListInit,
			showSearch: false,
			searchCount: null,
			renderKey: 0
		};
	}
	
	copyProjectSearch() {
		var projectSearchCopy = this.copyColumns(projectSearch);
		
		if (this.props.user.jobtrack && this.props.user.jobtrack.authLevel > 3) {
			// find speedtype column
			var speedtypeCol = this.findColumnByAccessor(projectSearchCopy.columns, 'SPEEDTYPE');
			
			// auth level 4 can only see speedtypes from their PI's projects
			if (this.props.user.jobtrack.piRoleIDs.length > 0) {
				projectSearchCopy.columns[speedtypeCol].options.search =
					{ Attribute: 'PI_ROLE', Operator: 'in', LongList: this.props.user.jobtrack.piRoleIDs };
			}
		}
		
		return projectSearchCopy;
	}
	
	addProject() {
		this.props.navigate('/Jobtrack/Projects/new');
	}
	
	editProject(projectId) {
		this.props.setProjectEditable(true);
		this.props.navigate('/Jobtrack/Projects/' + projectId);
	}
	
	viewProject(projectId) {
		this.props.setProjectEditable(false);
		this.props.navigate('/Jobtrack/Projects/' + projectId);
	}

	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search }, () => {
			if (accessor === 'PAGE_SEARCH') window.find(value);
		});
	}

	onExpandSearch(event) {
		this.mergeState({
			showSearch: true,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();		
	}

	onSubmitSearch(event, newOrderBy) {
		// copy search in case we need to incorporate the new ordering
		var search = this.copyObject(this.state.search);
		if (newOrderBy) search.ORDER_BY = newOrderBy;
		
		// copy search again 
		var newProjectList = this.copyTable(projectList);
		newProjectList.ajax.data = { search: this.copyObject(search) };
		
		this.mergeState({
			search: search,
			projectList: newProjectList,
			showSearch: false,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
	}
	
	onSearchResult(data) {		
		this.mergeState({
			searchCount: data.ResultCount,
		});
	}
	
	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			Action: 'Projects',
			columns: exportColumns,
			search: this.state.search
		});			
		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Project List</div>
						{this.state.showSearch && <ChemEdit parent={this} user={this.props.user} columns={this.state.projectSearch} data={this.state.search}
						  renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />}
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Jobtrack/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Jobtrack/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						{this.state.showSearch ?
							<Button id="update" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button> :
							<Button id="expand" variant="warning" type="button" className="float-end" onClick={(event) => this.onExpandSearch(event)}>Modify Search</Button>
						}
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='Jobtrack_Projects' table={this.state.projectList}
				    order={this.state.search.ORDER_BY} onTableSort={(newOrder) => this.onSubmitSearch(null, newOrder)}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='150px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const projectSearch = [
	{ Header: 'Project ID', accessor: 'PROJECT_ID', type: 'select', row: 0, col: 0,
		options: { value: 'PROJECT_ID', label: 'PROJECT_LABEL', entity: 'RECHARGES.PROJECT_DROPDOWN_VW', order: 'PROJECT_ID desc' }},
	{ Header: 'Name', accessor: 'PROJECT_NAME', row: 0, col: 1 },
	{ Header: 'Description', accessor: 'PROJECT_DESC', row: 0, col: 2 },
	{ Header: 'Started From', accessor: 'START_FROM', type: 'date', row: 1, col: 0 },
	{ Header: 'Started To', accessor: 'START_TO', type: 'date', row: 1, col: 1 },
	{ Header: 'Customer', accessor: 'CONTACT_ID', type: 'select', row: 1, col: 2,
		options: { value: 'CONTACT_ID', label: 'CUSTOMER', entity: 'RECHARGES.PROJ_CUST_SELECT_VW', order: 'CUSTOMER' }},
	{ Header: 'PI', accessor: 'PI_ID', type: 'select', row: 2, col: 0,
		options: { value: 'PI_ID', label: 'PI_NAME', entity: 'RECHARGES.PROJ_PI_SELECT_VW', order: 'PI_NAME' }},
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE', type: 'dropdown', row: 2, col: 1,
		options: { value: 'SPEEDTYPE', label: 'SPEEDTYPE', entity: 'RECHARGES.PROJ_CC_DROPDOWN_VW', order: 'SPEEDTYPE' }},
	{ Header: 'Status', accessor: 'STATUS_ID', type: 'select', row: 2, col: 2,
		options: { value: 'STATUS_ID', label: 'STATUS_NAME', entity: 'RECHARGES.JOB_STATUS_SELECT_VW', order: 'STATUS_NAME' }},
	{ Header: 'Updated From', accessor: 'MODIF_FROM', type: 'date', row: 3, col: 0 },
	{ Header: 'Updated To', accessor: 'MODIF_TO', type: 'date', row: 3, col: 1 },
	{ Header: 'Page Search', accessor: 'PAGE_SEARCH', row: 3, col: 2 }
];

const projectList = {
	ajax: { 
		url: '/JobTrack/GetProjects',
		data: null,
		accessor: 'Data'
	},
	pageSize: 20,
	columns: [
		{ Header: props => <PlusSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.addProject()} />, accessor: 'id', width: 25, 
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} onClick={() => props.parent.editProject(props.row.values.PROJECT_ID)} /> },
		{ Header: 'ID', accessor: 'PROJECT_ID', width: 60,
			Cell: props => <HashLink onClick={() => props.parent.viewProject(props.value)}>{props.value}</HashLink> },
		{ Header: 'Name', accessor: 'PROJECT_NAME', width: 125 },
		{ Header: 'Entered', accessor: 'ENTERED_DISPLAY', width: 125 },
		{ Header: 'Customer', accessor: 'CONTACT_NAME', width: 125 },
		{ Header: 'PI', accessor: 'PI_NAME', width: 125 },
		{ Header: 'Speedtype', accessor: 'SPEEDTYPE', width: 125 },
		{ Header: 'Status', accessor: 'STATUS_NAME', width: 125 },
		{ Header: 'Updated', accessor: 'UPDATED_DISPLAY', width: 125 }
	]
};

const exportColumns = [
	{ Header: 'ID', accessor: 'PROJECT_ID', width: 12 },
	{ Header: 'Name', accessor: 'PROJECT_NAME', width: 25 },
	{ Header: 'Entered', accessor: 'ENTERED_DISPLAY', width: 25 },
	{ Header: 'Customer', accessor: 'CONTACT_NAME', width: 25 },
	{ Header: 'PI', accessor: 'PI_NAME', width: 25 },
	{ Header: 'Speedtype', accessor: 'SPEEDTYPE', width: 25 },
	{ Header: 'Status', accessor: 'STATUS_NAME', width: 25 },
	{ Header: 'Updated', accessor: 'UPDATED_DISPLAY', width: 25 }
];

export default withRouter(Projects);
